import Viewpoint from '@arcgis/core/Viewpoint';
import { ObjectUtils } from '../utils/object.utils';
import { MapNoteModel } from './map-note.model';

export interface MapLayerVisibleLike {
  id?: string;
  layer: string;
  visible: boolean;
}

export interface MapModelLike {
  id?: string;
  name?: string;
  description?: string;
  favorite?: boolean;
  basemapId?: string;
  viewPoint?: __esri.Viewpoint;
  layers?: MapLayerVisibleLike[];
  notes?: MapNoteModel[];
}

export class MapModel implements MapModelLike {
  id?: string;
  name?: string;
  description?: string;
  favorite?: boolean;
  basemapId?: string;
  viewPoint?: __esri.Viewpoint;
  layers?: MapLayerVisibleLike[];
  notes?: MapNoteModel[];

  constructor(obj?: Partial<MapModelLike>) {
    this.id = obj?.id;
    this.name = obj?.name;
    this.description = obj?.description;
    this.favorite = obj?.favorite;
    this.basemapId = obj?.basemapId;
    this.viewPoint = !obj?.viewPoint ? null : parseViewpoint(obj.viewPoint);
    this.layers = !obj?.layers ? null : ObjectUtils.clone(obj?.layers);
    this.notes = obj?.notes?.map((x) => new MapNoteModel(x)) ?? [];
  }
}

function parseViewpoint(source: __esri.Viewpoint | string): __esri.Viewpoint {
  if (source) {
    if (source instanceof Viewpoint) {
      return source.clone();
    } else if (typeof source === 'string') {
      source = JSON.parse(source);
    }

    return Viewpoint.fromJSON(source);
  }

  return null;
}
